/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import PageLayout from "customComponents/LayoutContainers/PageLayout";
import Footer from "customComponents/Footer";
import MDReport from "./MDReport";

function EmployeeReport() {
  const [isLinkExpired, setLinkExpired] = useState(false);
  const { token } = useParams();

  const [isToday, setIsToday] = useState(false);

  return (
    <PageLayout>
      <MDBox p={2} width="100%" height="100vh" mx="auto">
        {isLinkExpired && (
          <MDBox display="flex" flexDirection="column" flex={1} alignItems="center">
            <MDTypography variant="medium" color="text">
              This link has expired.
            </MDTypography>
          </MDBox>
        )}

        {token && !isLinkExpired && (
          <MDReport
            token={token}
            isToday={true}
            onLinkExpired={(bool) => setLinkExpired(bool)}
            onToday={(bool) => setIsToday(bool)}
            isVisible={isToday}
          />
        )}

        {token && !isLinkExpired && (
          <MDReport
            token={token}
            isToday={false}
            onLinkExpired={(bool) => setLinkExpired(bool)}
            onToday={(bool) => setIsToday(bool)}
            isVisible={!isToday}
          />
        )}
      </MDBox>

      <Footer />
    </PageLayout>
  );
}

export default EmployeeReport;
